module.exports = __webpack_public_path__ + "static/media/basket.c4f5f274.svg";